import axiosInstance from '../utils/axiosInstance';
import { showAlert } from '../components/common/toastify/ToastContainer';
import { handleApiError } from '@/lib/handleApiError';

export const getCustomers = async (
  page,
  size,
  search,
  sortField,
  sortDirection,
) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/customer?page=${page}&size=${size}&searchTerm=${search}&sortBy=${sortField}&sortDir=${sortDirection}`,
    );
    if (res.status === 204) {
      return ['No Data Found'];
    }
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const createCustomer = async (customerData) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/customer',
      customerData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Customer created successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const updateCustomer = async (customerId, customerData) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/customer/${customerId}`,
      customerData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Customer updated successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const deleteCustomer = async (customerId) => {
  try {
    await axiosInstance.delete(`/SmartProAPI/api/customer/${customerId}`);
    showAlert('success', 'Customer deleted successfully');
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};
